export enum LegalDocumentTypeEnums {
    AdvisoryOpinion = 2,
    GuidanceLetter = 3,
    InterpretativeBulletin = 4,
    Memoranda = 5,
    Law = 7,
    Regulation = 8,
    ResolutionLetter = 21,
    DispositionAgreement = 22,
    AO = 23,
};